import useSlingApi from '@sdk/api/useSlingApi';
import { useMutation } from '@tanstack/react-query';
import { TaskTemplatePayload } from '@sdk/shiftTasks/types/apiTypes';

import { useShiftTasksBridge } from '@web/shiftTasks/ShiftTasksBridgeProvider/ShiftTasksBridgeProvider';
import { mapTaskTemplateAPIToUI } from '@web/shiftTasks/utils/mappers';

type EditTaskMutationPayload = {
  payload: TaskTemplatePayload;
  shouldUpdateTaskInstances: boolean;
};

export function useEditTaskTemplate(id: ID) {
  const { shiftTasks } = useSlingApi();
  const shiftTasksBridge = useShiftTasksBridge();

  const mutation = useMutation({
    mutationFn: async ({ payload, shouldUpdateTaskInstances }: EditTaskMutationPayload) => {
      const result = await shiftTasks.editTemplate(id, payload, shouldUpdateTaskInstances);
      return mapTaskTemplateAPIToUI(result.data);
    },
    onSuccess: (response) => {
      shiftTasksBridge.onEditTaskTemplate(response);
    },
  });

  return mutation;
}
